<template>
  <BasePageTemplate :title="successTitleString" :description="successDescriptionString">
    <div class="flex justify-center">
      <AnimatedIcon icon="success" class="size-12" />
    </div>
  </BasePageTemplate>
</template>

<script setup lang="ts">
import { BasePageTemplate } from "@authentication/ui";
import { AnimatedIcon } from "@common/ui/atoms/Icons/AnimatedIcon";
import { useTranslation } from "i18next-vue";
import { nextTick, onMounted } from "vue";

// Props
const props = defineProps({
  redirectTo: {
    type: String,
    required: true,
  },
});

// Variables
const { t } = useTranslation();

// Strings
const successDescriptionString = t("login.success_description");
const successTitleString = t("login.success_title");

// Hooks
onMounted(async () => {
  await nextTick(() => {
    setTimeout(() => {
      window.location.assign(props.redirectTo);
    }, 100);
  });
});
</script>
